import { Dialog } from 'src/components';
import { Grid } from '@material-ui/core';
import { type IVideo } from 'src/models';

interface Props {
	open: boolean;
	handleOpen: () => void;
	video: IVideo;
}

function VideoPreview({ handleOpen, open, video }: Props) {
	return (
		<Dialog
			content={
				<Grid container>
					<video controls style={{ maxWidth: '100%' }}>
						<source src={video.url} type={'video/mp4'} />
					</video>
				</Grid>
			}
			handleOpen={handleOpen}
			maxWidth={'md'}
			open={open}
			title={video.name || ''}
		/>
	);
}

export default VideoPreview;
